export default __webpack_public_path__ + "8ebf622a393af4a7256ac8c1b1deca3f.png";